import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CaseService } from '../../../shared/services/case.service';
import { PreSignService } from '../../../shared/services/preSign.service';
import { stat } from 'fs';

@Component({
  selector: 'guardian-confirmation-dialog',
  templateUrl: './guardinan-confirmation-dialog.component.html',
  styleUrls: ['./guardinan-confirmation-dialog.component.scss']
})
export class GuardianConfirmationDialogComponent implements OnInit {
  msg = '';
  acceptBtnLoader: boolean = false;
  denyBtnLoader: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<GuardianConfirmationDialogComponent>,

    private caseService: CaseService,

    private preSign: PreSignService,
  ) { }
  ngOnInit() {
  }

  actionButton(status){

    if(this.data.form == '3.4'){
      this.dialogRef.close(status);
      return status;
    }
    let d ={
      "status":""
    };

    if (status === 'Accept') {
      d.status = 'ACCEPT';
      this.acceptBtnLoader = true;
      this.denyBtnLoader = false;
      this.caseService.postGuardianAdlitem(this.data.org,this.data.case, d)
        .subscribe(formName => {
          this.acceptBtnLoader = false;
          this.denyBtnLoader = false;
          this.dialogRef.close();
          
        });
    } else if (status === 'Deny') {
      d.status = 'DENY';
      this.acceptBtnLoader = false;
      this.denyBtnLoader = true;
      this.caseService.postGuardianAdlitem(this.data.org,this.data.case, d)
        .subscribe(result => {
          this.acceptBtnLoader = false;
          this.denyBtnLoader = false;
          this.dialogRef.close();
        });
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/guardian-confirmation-dialog/guardian-confirmation-dialog.component.ts